angular.module('appMarketplace')
    .service('UrlService', ['$location', 'LZString', function ($location, LZString) {
        var service = this;
        var useCompression = true;

        //TODO Make @deprecated in favor of getURLParameter(name)
        service.getParamValuesFromUrl = function (url, paramName) {
            var values = [];

            var startIndex = url.indexOf('?') + 1;
            var params = url.substring(startIndex).split('&');
            jQuery(params).each(function (i, str) {
                var param = str.split('=');
                if (param[0] === paramName) {
                    values.push(decodeURIComponent(param[1]));
                }
            });

            return values.length !== 0 ? values : null;
        };

        var contextPath;

        service.getContextPath = function () {
            if (!contextPath) {
                contextPath = '/' + $location.absUrl().split('/')[3];
            }
            return contextPath;
        };

        /**
         * Creates absolute URL for given path.
         * @param path relative or absolute path
         * @returns {*} URL string
         */
        service.createAbsoluteUrl = function (path) {
            if (service.isAbsoluteUrl(path)) {
                return path;
            }

            return service.getContextPath() + (path && path.startsWith('/') ? '' : '/') + path;
        };

        service.isAbsoluteUrl = function (path) {
            return path && path.toLowerCase().startsWith('http');
        };

        /**
         * Creates absolute URL for given relative path.
         * @param path relative or absolute path
         * @param params object containing key-value that will be appended to url. Only primitive values are supported.
         * @returns {*} URL string
         */
        service.createAbsoluteUrlWithParams = function (path, params) {
            var url = service.createAbsoluteUrl(path);
            var paramsAppended = false;
            angular.forEach(params, function (value, key) {
                if (value !== null && value !== undefined) {
                    if (!paramsAppended) {
                        url += '?';
                        paramsAppended = true;
                    } else {
                        url += '&';
                    }
                    url += (key + '=' + value);
                }
            });
            return url;
        };

        service.getURLParameter = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
        };

        service.appendStateToCurrentUrl = function (state) {
            return $location.absUrl().split('#')[0] + "#" + state;
        };

        service.getHashFromUrl = function () {
            return ($location.absUrl().match(/#\/!?(.*?)(?=\?|$)/) || [])[1];
        };

        service.compressObject = function (obj) {
            if (!obj) {
                return '';
            }
            return encode(JSON.stringify(obj));
        };

        service.addCompressedObjectToUrl = function (name, obj) {
            $location.search(name, service.compressObject(obj));
        };

        service.getDecompressedObjectFromUrl = function (name) {
            if (!$location.search()[name]) {
                return;
            }
            var decodedStr = $location.search()[name];
            return JSON.parse(decode(decodedStr.replace(/ /g, '+')));
        };

        function encode(value) {
            if (useCompression) {
                return LZString.compressToEncodedURIComponent(value);
            } else {
                return encodeURIComponent(value);
            }
        }

        function decode(value) {
            if (useCompression) {
                return LZString.decompressFromEncodedURIComponent(value);
            } else {
                return decodeURIComponent(value);
            }
        }

        /**
         * Check that current URL contains given page.
         * @param page - string
         * @returns {boolean}
         */
        service.checkUrlContains = function (page) {
            return $location.absUrl().indexOf(page) !== -1;
        };
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/services/url-service.js
// module id = 278
// module chunks = 37